export default __webpack_public_path__ + "static/media/plus.3b89e468.svg";